<div class="chat-side-panel-container w-full overflow-auto h-full bg-white flex flex-col">

  <!-- Header: Avatar + Contact Info -->
  <div class="flex flex-col items-center pt-6 pb-5 px-4 border-b border-surface">
    <app-conversation-initials [contact]="conversation.contact" [rounded]="true" [conversationAvatarId]="conversation.avatarId"/>
    <div class="mt-3 text-center space-y-1">
      <div class="font-semibold text-color leading-6">{{ conversation.contact | contactDisplay: conversation.fromNumber }}</div>
      @if (conversation.contact?.company) {
        <div class="text-sm text-muted-color">
          {{ conversation.contact!.company!.name }}
          @if (conversation.contact!.company!.code) {
            &nbsp;·&nbsp;<span class="font-mono text-xs">{{ conversation.contact!.company!.code }}</span>
          }
        </div>
      }
      @if (primaryPhone) {
        <div class="text-sm text-muted-color">{{ primaryPhone }}</div>
      }
    </div>
  </div>

  <!-- Targhe Recenti -->
  @if (plateDetectionEnabled && conversation.recentPlates?.length) {
    <div class="px-4 pt-4 pb-3 border-b border-surface">
      <h5 class="text-xs font-semibold uppercase tracking-wide text-muted-color mb-3">Targhe Recenti</h5>
      <div class="flex flex-wrap gap-1.5">
        @for (plate of conversation.recentPlates!; track plate) {
          <button class="plate-tag" (click)="copyPlate(plate)">
            <span>{{ plate }}</span>
            <i class="fa-light"
               [class.fa-copy]="copiedPlate !== plate"
               [class.fa-check]="copiedPlate === plate"></i>
          </button>
        }
      </div>
    </div>
  }

  <!-- Allegati (media) -->
  <div class="px-4 pt-4 pb-3">
    <h5 class="text-xs font-semibold uppercase tracking-wide text-muted-color mb-3">Allegati</h5>

    @if (media.length === 0) {
      <p class="text-sm text-muted-color text-center py-4">Nessun allegato.</p>
    } @else {
      <div class="media-grid-scroll" (scroll)="onMediaGridScroll($event)">
        <div class="grid grid-cols-4 gap-1 p-1">
          @for (med of media; track $index) {
            <div
              class="media-thumb-cell"
              [class.selected]="selectedMedia === med"
              (click)="selectMedia(med)"
              [ngSwitch]="mimeCategory(med)"
            >
              <p-image *ngSwitchCase="'image'" [src]="med.mediaUrl" class="w-full h-full"/>
              <div *ngSwitchCase="'video'" class="icon-cell"><i class="fa-light fa-video text-primary text-lg"></i></div>
              <div *ngSwitchCase="'audio'" class="icon-cell"><i class="fa-light fa-volume-high text-primary text-lg"></i></div>
              <div *ngSwitchDefault class="icon-cell"><i class="fa-light fa-file text-primary text-lg"></i></div>
            </div>
          }
        </div>
      </div>
    }

    @if (!hideLoadMoreMedia) {
      <div class="flex justify-center mt-3">
        <button class="load-more-btn" (click)="loadMore('media')">
          <i class="fa-light fa-chevron-down"></i>
          <span>Mostra altri</span>
        </button>
      </div>
    }

    <!-- Media Preview (always rendered to prevent layout shift) -->
    <div class="item-preview-container mt-3" [class.item-preview-container--empty]="!selectedMedia">
      @if (selectedMedia) {

        @if (mimeCategory(selectedMedia) === 'image' && selectedMedia.mediaUrl) {
          <div class="media-detail-preview">
            <img [src]="selectedMedia.mediaUrl" alt="" />
          </div>
        }

        <div class="p-3 flex items-start gap-3">
          <div class="flex-shrink-0 mt-0.5">
            @switch (mimeCategory(selectedMedia)) {
              @case ('image') { <i class="fa-light fa-image text-primary text-base"></i> }
              @case ('video') { <i class="fa-light fa-video text-primary text-base"></i> }
              @case ('audio') { <i class="fa-light fa-volume-high text-primary text-base"></i> }
              @default        { <i class="fa-light fa-file text-primary text-base"></i> }
            }
          </div>

          <div class="flex-1 min-w-0">
            <div class="text-sm font-medium text-color truncate">{{ selectedMedia.fileName || 'Allegato' }}</div>
            @if (selectedMedia.creationDate) {
              <div class="text-xs text-muted-color mt-0.5">{{ selectedMedia.creationDate | date:'d MMM yyyy · HH:mm' }}</div>
            }

            @if (hasAiContent(selectedMedia)) {
              @if (selectedMedia.aiInsights; as ai) {
                <div class="ai-detail-section">
                  <button class="ai-detail-header" (click)="aiDetailExpanded = !aiDetailExpanded">
                    <span class="ai-detail-label">
                      <i class="fa-light fa-sparkles"></i>
                      Analisi AI
                    </span>
                    <i class="fa-light fa-chevron-down ai-detail-chevron" [class.rotated]="aiDetailExpanded"></i>
                  </button>

                  @if (aiDetailExpanded) {
                    <div class="ai-detail-body">

                      @if (audioTranscriptionEnabled) {
                        @if (ai.audioTranscription; as tr) {
                          @if (tr.status === 'COMPLETE' && tr.result) {
                            <p class="text-xs text-color leading-relaxed">{{ tr.result }}</p>
                          } @else if (tr.status === 'PENDING') {
                            <span class="ai-detail-pending">
                              <i class="fa-light fa-circle-notch fa-spin"></i>
                              Trascrizione in corso…
                            </span>
                          }
                        }
                      }

                      @if (plateDetectionEnabled) {
                        @if (ai.plateDetection; as pd) {
                          @if (pd.status === 'COMPLETE' && pd.result.length > 0) {
                            <div class="flex flex-wrap gap-1">
                              @for (plate of pd.result; track plate) {
                                <button class="plate-tag" (click)="copyPlate(plate)">
                                  <span>{{ plate }}</span>
                                  <i class="fa-light"
                                     [class.fa-copy]="copiedPlate !== plate"
                                     [class.fa-check]="copiedPlate === plate"></i>
                                </button>
                              }
                            </div>
                          }
                        }
                      }

                    </div>
                  }
                </div>
              }
            }
          </div>

          <button class="flex-shrink-0 text-primary hover:opacity-70 transition-opacity mt-0.5" (click)="openDocument(selectedMedia)">
            <i class="fa-light fa-arrow-up-right-from-square text-base"></i>
          </button>
        </div>

      } @else {
        <div class="item-preview-placeholder">
          <i class="fa-light fa-image-landscape"></i>
          <span>Seleziona un allegato per i dettagli</span>
        </div>
      }
    </div>
  </div>

  <!-- Preventivi -->
  <div class="px-4 pt-4 pb-3 border-t border-surface">
    <h5 class="text-xs font-semibold uppercase tracking-wide text-muted-color mb-3">Preventivi</h5>

    @if (quotes.length === 0) {
      <p class="text-sm text-muted-color text-center py-4">Nessun preventivo.</p>
    } @else {
      <div class="media-grid-scroll" (scroll)="onQuotesGridScroll($event)">
        <div class="grid grid-cols-4 gap-1 p-1">
          @for (quote of quotes; track $index) {
            <div
              class="media-thumb-cell icon-cell"
              [class.selected]="selectedQuote === quote"
              (click)="selectQuote(quote)"
            >
              <i class="fa-light fa-folder text-primary text-xl"></i>
              <span class="text-[10px] text-primary mt-1 truncate w-full px-1 text-center leading-tight">
                {{ (quote.fileName || 'Doc') | slice:0:8 }}{{ (quote.fileName && quote.fileName.length > 8) ? '…' : '' }}
              </span>
            </div>
          }
        </div>
      </div>
    }

    @if (!hideLoadMoreQuotes) {
      <div class="flex justify-center mt-3">
        <button class="load-more-btn" (click)="loadMore('quotes')">
          <i class="fa-light fa-chevron-down"></i>
          <span>Mostra altri</span>
        </button>
      </div>
    }

    <!-- Quote Preview (always rendered to prevent layout shift) -->
    <div class="item-preview-container mt-3" [class.item-preview-container--empty]="!selectedQuote">
      @if (selectedQuote) {
        <div class="p-3 flex items-start gap-3">
          <div class="flex-shrink-0 w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center">
            <i class="fa-light fa-folder-open text-primary text-lg"></i>
          </div>
          <div class="flex-1 min-w-0">
            <div class="text-sm font-semibold text-color truncate">{{ selectedQuote.fileName || 'Preventivo' }}</div>
            @if (selectedQuote.creationDate) {
              <div class="text-xs text-muted-color mt-0.5">{{ selectedQuote.creationDate | date:'d MMM yyyy · HH:mm' }}</div>
            }
            @if (selectedQuote.caption) {
              <p class="text-xs text-color mt-1.5 leading-relaxed">{{ selectedQuote.caption }}</p>
            }
          </div>
          <button class="flex-shrink-0 text-primary hover:opacity-70 transition-opacity" (click)="openDocument(selectedQuote)">
            <i class="fa-light fa-arrow-up-right-from-square text-base"></i>
          </button>
        </div>
      } @else {
        <div class="item-preview-placeholder">
          <i class="fa-light fa-folder"></i>
          <span>Seleziona un preventivo per i dettagli</span>
        </div>
      }
    </div>
  </div>

</div>
